<template>
  <div class="baseMapRight">
    <div class="baseMapTitle">
      <span href="#" v-for="(item,index) in navigationList" :key="index">
        {{item.barName?item.barName:item[parentEle.title]}}
        <span v-if="index!=navigationList.length-1">></span>
      </span>
    </div>
    <div class="baseMapContent">
      <div id="container"></div>
      <pre class="content">
        咨询方式：

        1、在线咨询

        2、QQ: 2355349288

        3、邮箱：summysang@worldelite.net.cn

        4、联系电话：总机 86-755-89983786、 86-755-89623778 桑小姐 86-755-27820196、13590489275 张先生 13632690504

        地址：深圳市龙岗区龙岗街道龙盛路8号香玉儿工业园综合办公楼5楼
      </pre>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    currentObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      navigationList:[],
      currentPage: 1,
      total: 0
    }
  },
   watch: {
    currentObj: {
      deep: true,
      handler: function () {
        this.navigationList = JSON.parse(sessionStorage.getItem('pathList'))
      }
    }
  },
  inject: ['parentEle'],
  mounted() {
    var map = new BMapGL.Map("container");    // 创建Map实例
    map.centerAndZoom(new BMapGL.Point(116.404, 39.915), 11);  // 初始化地图,设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
    map.addControl(scaleCtrl);
    var zoomCtrl = new BMapGL.ZoomControl();  // 添加比例尺控件
    map.addControl(zoomCtrl);
   

    
  },
  methods: {
    handleCurrentChange(val) {

    }
  }
}
</script>
<style scoped lang="less">
.baseMapRight {
  width: 714px;
  float: right;
  .baseMapTitle {
    height: 27px;
    padding-top: 6px;
    background: url("http://www.worldelite.net.cn/data/templates/cn/img/title_bg.jpg")
      repeat-x;
    line-height: 27px;
    padding-left: 12px;
    color: #747575;
    text-align: left;
    & > span {
      color: #747575;
      cursor: pointer;
    }
    & > span:last-child {
      cursor: initial;
    }
  }
  .baseMapContent {
    #container {
      height: 300px;
      margin-top: 10px;
      margin-bottom: 30px;
    }
    .content {
      padding: 20px 0;
      border-top: 1px solid #ccc;
      text-align: left;
    }
  }
}
</style>